/**
 * Wrapper rendered in commentThread.comment.header slot.
 * Resolves commentId → annotationId via store and delegates to
 * CommentVisibilityBadge only for the first comment in each thread.
 * Runs in its own ReactDOM.createRoot — no MUI/ThemeProvider. Styles: pdf-review.css
 */

import React, {useSyncExternalStore} from 'react';
import PropTypes from 'prop-types';

import {commentVisibilityStore} from '../store/commentVisibilityStore';
import CommentVisibilityBadge from './CommentVisibilityBadge';

const CommentBadgeByCommentId = ({commentId, instance}) => {
  const {firstCommentIds} = useSyncExternalStore(
    commentVisibilityStore.subscribe,
    commentVisibilityStore.getSnapshot
  );

  if (!firstCommentIds?.has(commentId)) return null;

  const annotationId =
    commentVisibilityStore.getAnnotationForComment(commentId);
  if (!annotationId) return null;

  return (
    <CommentVisibilityBadge annotationId={annotationId} instance={instance} />
  );
};

CommentBadgeByCommentId.propTypes = {
  commentId: PropTypes.string.isRequired,
  instance: PropTypes.object,
};

export default CommentBadgeByCommentId;
